import { Injectable } from '@angular/core';
import { LoggerService } from 'src/app/core/services/logger.service';
import { ContatoEvento } from 'src/app/shared/models/contato-evento.models';

@Injectable({
  providedIn: 'root',
})
export class EventHandlerService {
  private itemStorage: string = 'processedContacts';
  private processedContacts: Set<string> = new Set<string>();

  constructor(private logger: LoggerService) {
    const storedContacts = JSON.parse(localStorage.getItem(this.itemStorage) || '[]');
    this.processedContacts = new Set(storedContacts);
  }

  add(contact: ContatoEvento): void {
    this.processedContacts.add(contact.id);
    this.saveProcessedContacts();
  }

  remove(contact: ContatoEvento): void {
    this.processedContacts.delete(contact.id);
    this.saveProcessedContacts();
  }

  isProcessed(contact: ContatoEvento): boolean {
    const checkuser = this.processedContacts.has(contact.id);
    return checkuser;
  }

  clearProcessed(): void {
    localStorage.removeItem(this.itemStorage);
    this.processedContacts.clear();
    this.logger.info('EVENTHANDLER - Todos os contatos processados foram removidos.');
  }

  private saveProcessedContacts(): void {
    localStorage.setItem(this.itemStorage, JSON.stringify(Array.from(this.processedContacts)));
  }
}
